// extracted by mini-css-extract-plugin
export default {"frameWrap":"OneTimeLogin_frameWrap__KeCii","inputWrap":"OneTimeLogin_inputWrap__11jXC","logoWrap":"OneTimeLogin_logoWrap__KssR-"};